const FREE_SHIPPING_THRESHOLD = 6999000;

function updateFreeShippingBar(cartTotal) {
  const bar = document.getElementById('free-shipping-bar');
  if (!bar) return;

  const remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
  const progress = Math.min((cartTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
  const fill = bar.querySelector('.free-shipping-bar__fill');
  const message = bar.querySelector('.free-shipping-bar__message');

  if (fill) fill.style.width = progress + '%';

  if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
    message.innerHTML = 'Tienes envio gratis!';
    message.className = 'free-shipping-bar__message free-shipping-bar__message--success';
  } else {
    const remainingFormatted = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(remaining / 100);
    message.innerHTML = 'Te faltan <strong>' + remainingFormatted + '</strong> para envio gratis';
    message.className = 'free-shipping-bar__message';
  }
}

function initBar() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateFreeShippingBar(cart.total_price); });
}

initBar();

document.addEventListener('click', function() {
  setTimeout(initBar, 300);
  setTimeout(initBar, 800);
});

document.addEventListener('cart:updated', function(e) {
  if (e.detail && e.detail.cart) {
    updateFreeShippingBar(e.detail.cart.total_price);
  }
});
